export interface Esr {
  amount?: string;
  currency?: string;
  referenceNumber?: string;
  accountNumber?: string;
  slipType?: string;
}

export class EsrParser {
  public static validateReferenceNumber = (referenceNumber) => {
    let ref = String(referenceNumber);

    // no empty spaces
    if (ref.trim().length === 0) {
      return false;
    }

    // only digits and spaces are allowed
    if (/^[0-9\s]*$/.test(ref) === false) {
      return false;
    }

    // remove all spaces
    ref = ref.replace(/\D/g, '');

    // too long?
    if (ref.length > 27) {
      return false;
    }

    // table used to check mod 10
    const modTable = [0, 9, 4, 6, 8, 2, 7, 1, 3, 5];

    // split the reference number into an array so we can easily use it with the checking table
    const refArray = ref.split('');
    let remainder = 0;
    for (let j = 0; j < ref.length - 1; j++) {
      const current = parseInt(String(remainder), 10) + parseInt(refArray[j], 10);
      remainder = modTable[current % 10]; // do mod 10 on the table
    }

    // get the calculated check number
    //eslint-disable-next-line @typescript-eslint/naming-convention
    const check_calculated = (10 - remainder) % 10;

    // get the check from the given reference number
    //eslint-disable-next-line @typescript-eslint/naming-convention
    const check_given = Number(ref.substring(ref.length - 1, ref.length));

    // the reference number is valid if our calculated check equals the given check
    const valid = check_calculated === check_given;

    // done ... return result
    return valid;
  };

  public static parse(code: string): Esr {
    if (!code) {
      return {};
    }

    let esr: Esr = {};

    try {
      const type = code.slice(0, 2);
      const part = code
        .split(/\+|>/g)
        .map((p) => p.trim())
        .filter((p) => p.length > 0);

      if (type === '01' || type === '21') {
        if (EsrParser.validateReferenceNumber(part[1])) {
          // ESR
          esr.currency = type === '21' ? 'EUR' : 'CHF';
          esr.amount = parseFloat(`${part[0].slice(2, part[0].length - 3)}.${part[0].slice(-3, -1)}`).toFixed(2);
          esr.slipType = type;
          esr.referenceNumber = EsrParser.formatReferenceNumber(part[1]);
          esr.accountNumber =
            `${part[2].slice(0, 2)}-` + `${part[2].slice(2, part[2].length - 1).replace(/^[0]*/, '')}-` + `${part[2].slice(-1)}`;
        }
      }

      if (type === '04' || type === '31') {
        if (EsrParser.validateReferenceNumber(part[1])) {
          // ESR+
          esr.currency = type === '31' ? 'EUR' : 'CHF';
          esr.amount = '';
          esr.slipType = type;
          esr.referenceNumber = EsrParser.formatReferenceNumber(part[1]);
          esr.accountNumber =
            `${part[2].slice(0, 2)}-` + `${part[2].slice(2, part[2].length - 1).replace(/^[0]*/, '')}-` + `${part[2].slice(-1)}`;
        }
      }
    } catch (e) {
      esr = {};
    }

    return esr;
  }

  public static formatReferenceNumber(refNumber: string): string {
    if (!refNumber) {
      return refNumber;
    }

    if (refNumber.length === 27) {
      const parts = refNumber
        .slice(2)
        .split(/(.{5})/)
        .filter((p) => p.length === 5);
      return `${refNumber.slice(0, 2)} ${parts.join(' ')}`;
    }

    if (refNumber.length === 16) {
      const parts = refNumber.split(new RegExp('(.{4})')).filter((p) => p.length === 4);
      return `${parts.join(' ')}`;
    }

    return refNumber;
  }

  public static pad = (s: string, n: number): string => {
    let zeros = '';
    for (let i = 0; i < n - s.length; i++) {
      zeros += '0';
    }
    return zeros + s;
  };
}
